import { render, staticRenderFns } from "./Ryzodeg.vue?vue&type=template&id=1e4ef99f&scoped=true&"
import script from "./Ryzodeg.vue?vue&type=script&lang=js&"
export * from "./Ryzodeg.vue?vue&type=script&lang=js&"
import style0 from "./Ryzodeg.vue?vue&type=style&index=0&id=1e4ef99f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ef99f",
  null
  
)

export default component.exports